import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-paginator',
	templateUrl: './paginator.component.html',
	styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {

	@Input() public prevPage!: () => void;
	@Input() public nextPage!: () => void;
	@Input() public prevDisabled = true;
	@Input() public nextDisabled = true;
	@Input() public resultSize = 0;

	constructor() { }

	ngOnInit(): void {
	}


}
